var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillsBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1784,
    height: 791,
    viewBox: "0 0 1784 791",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1470.63,
    y: 1186.75,
    width: 808,
    height: 452,
    rx: 226,
    transform: "rotate(-136.144 1470.63 1186.75)",
    fill: "url(#paint0_radial_443_734)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -277,
    y: 270.798,
    width: 808,
    height: 452,
    rx: 226,
    transform: "rotate(-19.5814 -277 270.798)",
    fill: "url(#paint1_radial_443_734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_443_734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2370.63 207.752) rotate(105.64) scale(1508.93 2698.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9EF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_443_734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(623 -708.202) rotate(105.64) scale(1508.93 2698.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9EF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillsBottom);
export default __webpack_public_path__ + "static/media/pills_bottom.344d4e6d298951f4d020ed677c0140f5.svg";
export { ForwardRef as ReactComponent };